const t = "container_QJFQt", n = "content_MfEpL", o = "title_23m2b", r = "error_dE2b-", e = "buttons_kk-OV", c = "primaryButton_7JUYl", s = "secondaryButton_9toCo", a = {
  container: t,
  content: n,
  title: o,
  error: r,
  buttons: e,
  primaryButton: c,
  secondaryButton: s
};
export {
  e as buttons,
  t as container,
  n as content,
  a as default,
  r as error,
  c as primaryButton,
  s as secondaryButton,
  o as title
};
//# sourceMappingURL=phoneInputForm.module.scss.js.map
